import React, { useState, useEffect } from 'react';
import { shareAPI } from '../services/api';
import '../styles/UserSearchAutocomplete.css';

const UserSearchAutocomplete = ({ onSelect, selectedUser }) => {
  const [query, setQuery] = useState('');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const searchUsers = async () => {
      if (query.length < 2) {
        setUsers([]);
        setShowDropdown(false);
        return;
      }

      setLoading(true);
      try {
        const response = await shareAPI.searchUsers(query);
        setUsers(response.data);
        setShowDropdown(true);
      } catch (error) {
        console.error('Failed to search users:', error);
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };

    const timeoutId = setTimeout(searchUsers, 300);
    return () => clearTimeout(timeoutId);
  }, [query]);

  const handleSelect = (user) => {
    onSelect(user);
    setQuery('');
    setShowDropdown(false);
  };

  return (
    <div className="user-search-autocomplete">
      <input
        type="text"
        className="form-control"
        placeholder="Search users by name or email..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onFocus={() => query.length >= 2 && setShowDropdown(true)}
      />

      {loading && <div className="search-loading">Searching...</div>}

      {showDropdown && users.length > 0 && (
        <div className="search-dropdown">
          {users.map((user) => (
            <div
              key={user.id}
              className="search-result-item"
              onClick={() => handleSelect(user)}
            >
              <div className="user-info">
                <div className="user-name">{user.username}</div>
                <div className="user-email">{user.email}</div>
              </div>
              <div className="user-role">{user.role}</div>
            </div>
          ))}
        </div>
      )}

      {showDropdown && query.length >= 2 && users.length === 0 && !loading && (
        <div className="search-dropdown">
          <div className="no-results">No users found</div>
        </div>
      )}
    </div>
  );
};

export default UserSearchAutocomplete;
